import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ModalBase from "./ModalBase";
import { useModal } from "../../js/hooks/useModal";
import { lookupClientAccess, portalPathForClient } from "../../js/api/clientAccess";
import { writeClientPortal } from "../../js/hooks/useClientPortal";

export default function ClientAccessModal() {
  const modal = useModal("clientAccess");
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [verify, setVerify] = useState("");
  const [error, setError] = useState("");

  function close() {
    setCode("");
    setVerify("");
    setError("");
    modal.close();
  }

  function submit(event) {
    event.preventDefault();
    const result = lookupClientAccess({ code, verify });
    if (!result.ok) {
      setError(result.error);
      return;
    }
    writeClientPortal(result.client);
    close();
    navigate(portalPathForClient(result.client));
  }

  return (
    <ModalBase isOpen={modal.isOpen} title="Client Access" onClose={close} compact>
      <p className="muted">
        Enter the Client ID your agent gave you. You will only see your buyer or seller portal — never
        the professional desk.
      </p>
      <form className="client-access__form" onSubmit={submit}>
        <label>
          Client ID
          <input
            value={code}
            onChange={(event) => setCode(event.target.value)}
            placeholder="RC-BY-4821"
            autoComplete="off"
          />
        </label>
        <label>
          Last name or email <span className="muted">(optional)</span>
          <input value={verify} onChange={(event) => setVerify(event.target.value)} />
        </label>
        {error ? <p className="field-error">{error}</p> : null}
        <div className="btn-row">
          <button type="submit" className="primary-btn">
            Open My Portal
          </button>
          <button type="button" className="ghost-btn" onClick={close}>
            Cancel
          </button>
        </div>
      </form>
    </ModalBase>
  );
}
